<!-- Modal (Tags (Clientes)) -->

<ng-template #tagsClientes let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-tags-clientes"><b>Tags (Clientes)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-row">
      <div class="form-group col-sm-12">
        <label><b>Cliente:</b></label>

        <input class="form-control form-control-sm" type="text" name="cliente_tag" [value]="tagClienteNomeSelecionado" disabled />
      </div>
    </div>

    <hr class="mt-2 mb-2" />

    <div class="form-row mb-2">
      <div class="form-group col-sm-12">
        <label><b>Tags:</b></label>

        <input type="text" class="form-control" [(ngModel)]="tagCliente">
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Salvar')">Salvar</button>
  </div>
</ng-template>

@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="titulo_texto">Dashboard - Oportunidades</div>
    </div>
    <div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
      <!-- Filtro -->
      <div class="filtros-barra">
        <button class="btn btn-outline-primary" type="button" (click)="filtrosRecolhidos = !filtrosRecolhidos"
          [attr.aria-expanded]="!filtrosRecolhidos" aria-controls="painel-filtros-oportunidades"
          [attr.aria-label]="filtrosRecolhidos ? 'Abrir filtros' : 'Recolher filtros'"
          [title]="filtrosRecolhidos ? 'Abrir filtros' : 'Recolher filtros'">
          <i class="fa fa-filter" aria-hidden="true"></i> Clique para Filtrar
        </button>
      </div>
      <form id="painel-filtros-oportunidades" class="filtros-oportunidades" [hidden]="filtrosRecolhidos" [formGroup]="formFiltro" (ngSubmit)="filtrar()">
        <div class="filtros-cabecalho"><b>Filtros combinados</b><span class="text-secondary">Todos os filtros preenchidos serão aplicados juntos (AND).</span></div>
        @if (carregandoOpcoes) { <p role="status">Carregando listas...</p> }
        @if (erroOpcoes) { <p role="alert" class="text-danger">Erro ao carregar listas. <button type="button" class="btn btn-link btn-sm" (click)="carregarOpcoes()">Tentar novamente</button></p> }
        <div class="filtros-grid">
          <div><label class="text-secondary"><b>Cidade</b></label>
            <app-filtro-selecao label="Cidade" [opcoes]="opcoes.cidades" [value]="f.cidade.value" [disabled]="carregandoOpcoes" (valueChange)="alterarCidade($event)" />
          </div>
          <div><label class="text-secondary"><b>Bairro</b></label>
            <app-filtro-selecao label="Bairro" [opcoes]="opcoes.bairros" [value]="f.bairro.value" [disabled]="carregandoOpcoes || carregandoBairros || erroBairros" (valueChange)="f.bairro.setValue($event)" />
            @if (carregandoBairros) { <small role="status">Carregando bairros...</small> }
            @if (erroBairros) { <small class="text-danger">Erro ao carregar bairros. <button type="button" class="btn btn-link btn-sm" (click)="alterarCidade(f.cidade.value)">Tentar novamente</button></small> }
          </div>
          <div><label class="text-secondary"><b>Classificação</b></label>
            <app-filtro-selecao label="Classificação" [opcoes]="opcoes.classificacoes" [value]="f.classificacao.value" [disabled]="carregandoOpcoes" (valueChange)="f.classificacao.setValue($event)" />
          </div>
          <div><label class="text-secondary"><b>Segmento</b></label>
            <app-filtro-selecao label="Segmento" [opcoes]="opcoes.segmentos" [value]="f.segmento.value" [disabled]="carregandoOpcoes" (valueChange)="f.segmento.setValue($event)" />
          </div>
          <div><label for="opp-cliente" class="text-secondary"><b>Cliente</b></label><input id="opp-cliente" class="form-control form-control-sm" formControlName="cliente" type="text" /></div>
          <div><label for="opp-cnpj_cpf" class="text-secondary"><b>CNPJ/CPF</b></label><input id="opp-cnpj_cpf" class="form-control form-control-sm" formControlName="cnpj_cpf" type="text" /></div>
          <div><label for="opp-codigo" class="text-secondary"><b>Código</b></label><input id="opp-codigo" class="form-control form-control-sm" formControlName="codigo" type="text" /></div>
          <div><label class="text-secondary"><b>Vendedor(a)</b></label>
            <app-filtro-selecao label="Vendedor(a)" [opcoes]="opcoes.vendedores" [value]="f.vendedor.value" [disabled]="carregandoOpcoes" mensagemVazia="Nenhum usuário ativo encontrado nesta empresa." (valueChange)="f.vendedor.setValue($event)" />
          </div>
          <div><label class="text-secondary"><b>Tags</b></label>
            <app-filtro-selecao label="Tags" placeholder="Adicionar tag" [opcoes]="opcoes.tags" [disabled]="carregandoOpcoes" [permitirLimpar]="false" mensagemVazia="Nenhuma tag cadastrada nos clientes desta empresa." (valueChange)="adicionarTag($event)" />
            <div class="tags-selecionadas">@for (tag of tagFiltro; track tag) { <button type="button" class="badge badge-info" (click)="removerTag(tag)" [attr.aria-label]="'Remover tag ' + tag">{{ tag }} &times;</button> }</div>
          </div>
          <div class="filtro-produto"><label class="text-secondary"><b>Produto</b></label>
            <div class="d-flex"><input class="form-control form-control-sm" [value]="produtoSelecionado?.name || ''" readonly aria-label="Produto selecionado" />
              <button class="btn btn-outline-primary btn-sm ml-1" type="button" (click)="buscarProduto()">{{ mostrarBuscaProduto ? 'Fechar' : 'Buscar' }}</button>
              @if (produtoSelecionado) { <button type="button" class="btn btn-outline-secondary btn-sm ml-1" (click)="produtoSelecionado = null" aria-label="Remover produto">&times;</button> }
            </div>
          </div>
          @for (intervalo of intervalos; track intervalo.inicio) {
            <fieldset class="intervalo"><legend>{{ intervalo.label }}</legend><div class="intervalo-campos">
              <div><label [for]="intervalo.inicio">{{ intervalo.inicio.startsWith('nro') ? 'Nro inicial' : 'Valor inicial' }}</label><input [id]="intervalo.inicio" type="number" min="0" step="1" class="form-control form-control-sm" [formControlName]="intervalo.inicio" placeholder="De" /></div>
              <span class="text-secondary">até</span>
              <div><label [for]="intervalo.fim">{{ intervalo.fim.startsWith('nro') ? 'Nro final' : 'Valor final' }}</label><input [id]="intervalo.fim" type="number" min="0" step="1" class="form-control form-control-sm" [formControlName]="intervalo.fim" placeholder="Até" /></div>
            </div></fieldset>
          }
        </div>
        @if (enviado && formFiltro.invalid) { <p class="text-danger mt-2" role="alert">Informe números inteiros não negativos, com início menor ou igual ao final de cada intervalo.</p> }
        <div class="filtros-acoes">
          <button class="btn btn-outline-secondary" type="button" [disabled]="buscando" (click)="limparFiltros()">Limpar filtros</button>
          <button class="btn btn-primary" type="submit" [disabled]="buscando">{{ buscando ? 'Filtrando...' : 'Aplicar filtros' }}</button>
        </div>
      </form>
      <!-- Produto -->
      @if (mostrarBuscaProduto && !filtrosRecolhidos) {
        @if (carregandoProdutos) { <p role="status">Carregando produtos...</p> }
        <!-- Buscar (Produto) -->
        <form [formGroup]="formFiltroProduto" (ngSubmit)="filtrarProduto()">
          <div class="form-row">
            <div class="form-group col-sm-2">
              <label class="text-secondary"><b>Filtrar Produto por:</b></label>
              <select class="form-control form-control-sm" name="filtrar_produto_por" formControlName="filtro" (change)="alterarFiltroProduto($event.target.value)">
                @for (opcao of filtroProdutos; track opcao) {
                  <option [value]="opcao.valor" [selected]="opcao.valor == fp.filtro.value">{{ opcao.texto }}</option>
                }
              </select>
            </div>
            <!-- Código -->
            @if (fp.filtro.value == 0) {
              <div class="form-group col-sm-2">
                <label class="text-secondary"><b>Código:</b></label>
                <input class="form-control form-control-sm" type="text" name="produto_codigo" [ngClass]="{ 'is-invalid': enviadoProduto && fp.codigo.errors?.required }" formControlName="codigo" />
                @if (enviadoProduto && fp.codigo.errors?.required) {
                  <div class="erro pt-1">Código em branco!</div>
                }
              </div>
            }
            <!-- Descrição -->
            @if (fp.filtro.value == 1) {
              <div class="form-group col-sm-7">
                <label class="text-secondary"><b>Descrição:</b></label>
                <input class="form-control form-control-sm" type="text" name="produto_descricao" [ngClass]="{ 'is-invalid': enviadoProduto && fp.descricao.errors?.required }" formControlName="descricao" />
                @if (enviadoProduto && fp.descricao.errors?.required) {
                  <div class="erro pt-1">Descrição em branco!</div>
                }
              </div>
            }
            <!-- Marca -->
            @if (fp.filtro.value == 2) {
              <div class="form-group col-sm-7">
                <label class="text-secondary"><b>Marca:</b></label>
                <input class="form-control form-control-sm" type="text" name="produto_marca" [ngClass]="{ 'is-invalid': enviadoProduto && fp.marca.errors?.required }" formControlName="marca" />
                @if (enviadoProduto && fp.marca.errors?.required) {
                  <div class="erro pt-1">Marca em branco!</div>
                }
              </div>
            }
            <div class="col-sm-3">
              <button class="btn btn-secondary btn_filtro" type="submit">Filtrar</button>
              @if (filtrandoProduto) {
                <button class="btn btn-secondary btn_filtro" type="button" (click)="alterarFiltroProduto(null)">Cancelar</button>
              }
            </div>
          </div>
        </form>
        @if (filtrandoProduto) {
          <div [@esvanecerDesvanecer]="'in'">
            <hr class="mt-2 mb-2" />
            <div class="filtrar_produto p-1">
              <div class="table-responsive">
                <cdk-virtual-scroll-viewport class="filtrar_produto_tabela" [itemSize]="10">
                  <table class="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th class="text-center">Código</th>
                        <th class="tabela_borda">Descrição</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *cdkVirtualFor="let produto of produtos; templateCacheSize: 0;">
                        <tr class="filtrar_produto_acao" (click)="selecionarProdutoFiltrado(produto.id)">
                          <td class="text-center">{{ produto.codigo }}</td>
                          <td class="tabela_borda">{{ produto.name }}</td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </cdk-virtual-scroll-viewport>
              </div>
            </div>
          </div>
        }
      }
      @if (oportunidades.length > 0) {
        <hr class="mt-2 mb-2" />
        <div class="d-flex quadro_estatistica justify-content-center">
          <div class="flex-grow-1">
            <div class="d-flex flex-wrap align-content-start justify-content-center">
              <!-- Qtde Clientes -->
              <div class="quadros_numeros_lg p-2">
                <div class="d-flex align-items-center">
                  <div class="pl-2 pr-2">
                    <i class="fa fa-users quadros_numeros_icones"></i>
                  </div>
                  <div class="quadros_numeros_textos">
                    {{ qtdeClientes }}<br />Qtde Clientes
                  </div>
                </div>
              </div>
              <!-- Qtde Clientes Padrão -->
              <div class="quadros_numeros_lg p-2">
                <div class="d-flex align-items-center">
                  <div class="pl-2 pr-2">
                    <i class="fa fa-users quadros_numeros_icones"></i>
                  </div>
                  <div class="quadros_numeros_textos">
                    {{ qtdeClientesPadrao }}<br />Qtde Clientes Padrão
                  </div>
                </div>
              </div>
              <!-- Qtde Clientes Adicionais -->
              <div class="quadros_numeros_lg p-2">
                <div class="d-flex align-items-center">
                  <div class="pl-2 pr-2">
                    <i class="fa fa-users quadros_numeros_icones"></i>
                  </div>
                  <div class="quadros_numeros_textos">
                    {{ qtdeClientesAdicionais }}<br />Qtde Clientes Adicionais
                  </div>
                </div>
              </div>
              <!-- Meta do Mês -->
              <div class="quadros_numeros_lg p-2">
                <div class="d-flex align-items-center">
                  <div class="pl-2 pr-2">
                    <i class="fa fa-dollar quadros_numeros_icones"></i>
                  </div>
                  <div class="quadros_numeros_textos">
                    {{ valorMetaMes | currency: 'BRL' }}<br />Meta do Mês
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Estatística (Clientes) -->
          <div class="flex-grow-1">
            <div class="d-flex justify-content-end">
              <div class="estatistica text-center p-2">
                <div>
                  <b>Estatística (Clientes)</b>
                </div>
                <div class="estatistica_quadro mt-3">
                  @for (estatistica of estatisticasClientes; track estatistica) {
                    <div class="d-flex justify-content-between pr-2 pb-2 pl-2">
                      <div class="estatistica_legenda mr-3" [ngClass]="estatistica.item"></div>
                      <div class="estatistica_legenda_descricao text-left">{{ estatistica.descricao }}</div>
                      <div class="estatistica_legenda_descricao text-right">{{ estatistica.qtde }}</div>
                      <div class="estatistica_legenda_descricao text-right">{{ estatistica.porcentagem | currency: 'BRL' : '' }}%</div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <hr class="mt-2 mb-2" />
      <div class="d-flex flex-column">
        @if (modelo_tela_ligacoes == 0) {
          <!-- Modelo 1 -->
          <!-- Exibição = Card -->
          @if (oportunidades.length > 0) {
            <div class="pb-2">
              <div class="form-row">
                <div class="form-group col-sm-2">
                  <label class="text-secondary"><b>Ordenar por:</b></label>
                  <select class="form-control form-control-sm" name="ordernar_oportunidades_por" [(ngModel)]="ordernarOportunidadesSelecionado" (change)="ordernarOportunidades($event.target.value)">
                    @for (opcao of ordernarOportunidadesOpcoes; track opcao) {
                      <option [value]="opcao.valor" [selected]="opcao.valor == ordernarOportunidadesSelecionado">{{ opcao.texto }}</option>
                    }
                  </select>
                </div>
                <div class="form-group col-sm-2">
                  <label class="text-secondary">&nbsp;</label>
                  <select class="form-control form-control-sm" name="ordernar_oportunidades_por_ordem" [(ngModel)]="ordernarOportunidadesOrdemSelecionado" (change)="ordernarOportunidadesOrdem($event.target.value)">
                    @for (opcao of ordernarOportunidadesOpcoesOrdem; track opcao) {
                      <option [value]="opcao.valor" [selected]="opcao.valor == ordernarOportunidadesOrdemSelecionado">{{ opcao.texto }}</option>
                    }
                  </select>
                </div>
              </div>
            </div>
          }
          <cdk-virtual-scroll-viewport class="tabela_xl" [itemSize]="20">
            <table class="tabela_card">
              <tbody>
                <tr *cdkVirtualFor="let oportunidade of oportunidades; let i = index; templateCacheSize: 0;">
                  <td>
                    <div class="d-flex flex-column justify-content-center tabela_card_item" [ngClass]="{ 'bg_tabela' : ((i % 2) == 0) }">
                      <div class="flex-grow-1">
                        <!-- Cliente -->
                        <div class="tabela_card_item_destaque mb-1">
                          <div class="d-flex justify-content-between">
                            <div class="d-flex">
                              <i class="fa fa-search-plus btn_tabela_acao pr-1" placement="right" ngbTooltip="Consultar" (click)="consultarCliente(oportunidade.client_id_app)"></i>
                              <i class="fa fa-tag btn_tabela_acao pr-1" placement="right" ngbTooltip="Tags (Clientes)" (click)="modalTagsClientes(tagsClientes, 'oportunidades', oportunidade.client_id_app)"></i>
                              <div>
                                {{ oportunidade.name }}
                              </div>
                            </div>
                            <div class="d-flex">
                              <div>
                                {{ oportunidade.cidade }}
                              </div>
                              @if (oportunidade.estado != null) {
                                <div>
                                  &nbsp;- {{ oportunidade.estado }}
                                </div>
                              }
                              @if (oportunidade.client_document != null) {
                                <div>
                                  &nbsp;- {{ oportunidade.client_document }}
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                        <div class="d-flex">
                          <div class="flex-grow-1">
                            <div class="d-flex flex-column">
                              <!-- Bagdes -->
                              <div class="d-flex mb-1">
                                <div class="tabela_card_item_badge pr-1">
                                  @if (oportunidade.relationship == 'Ativo') {
                                    <span class="badge badge-warning">Ativo</span>
                                  }
                                  @if (oportunidade.relationship == 'Ativo batido') {
                                    <span class="badge badge-success">Ativo (Batido)</span>
                                  }
                                  @if (oportunidade.relationship == 'Ativo Premium') {
                                    <span class="badge badge-other">Ativo (Premium)</span>
                                  }
                                  @if (oportunidade.relationship == 'Inativo') {
                                    <span class="badge badge-danger">Inativo</span>
                                  }
                                  @if (oportunidade.relationship == 'Prospecção') {
                                    <span class="badge badge-primary">Prospecção</span>
                                  }
                                </div>
                                @if (oportunidade.atencao == 'S') {
                                  <span class="atencao">&nbsp;</span>
                                }
                              </div>
                              <!-- Dados Complementares -->
                              <div class="tabela_card_item_quadro text-center mr-1">
                                <div class="d-flex flex-column">
                                  <table>
                                    @if (oportunidade.call_center_prox_agenda != null) {
                                      <tr>
                                        <td class="tabela_card_item_tabela_titulo">Agendamento</td>
                                        <td class="tabela_card_item_tabela_descricao">{{ oportunidade.call_center_prox_agenda | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                      </tr>
                                    }
                                    @if (callCenterConfiguracao != null && callCenterConfiguracao.mostra_classificacao) {
                                      <tr>
                                        <td class="tabela_card_item_tabela_titulo">Classificação</td>
                                        <td class="tabela_card_item_tabela_descricao">{{ oportunidade.classificacao }}</td>
                                      </tr>
                                    }
                                    @if (oportunidade.ultcomp != null && oportunidade.ultcomp != '') {
                                      <tr>
                                        <td class="tabela_card_item_tabela_titulo">Compra</td>
                                        <td class="tabela_card_item_tabela_descricao">{{ oportunidade.ultcomp | date: 'dd/MM/yyyy' }} - {{ oportunidade.qtdediasultcomp }} Dias</td>
                                      </tr>
                                    }
                                    <tr>
                                      <td class="tabela_card_item_tabela_titulo">Segmento</td>
                                      <td class="tabela_card_item_tabela_descricao">{{ oportunidade.segment }}</td>
                                    </tr>
                                    @if (oportunidade.ramo_atividade) {
                                      <tr>
                                        <td class="tabela_card_item_tabela_titulo">Ramo Atividade</td>
                                        <td class="tabela_card_item_tabela_descricao">{{ oportunidade.ramo_atividade }}</td>
                                      </tr>
                                    }
                                    @if (oportunidade.grupo_regiao) {
                                      <tr>
                                        <td class="tabela_card_item_tabela_titulo">Grupo Região</td>
                                        <td class="tabela_card_item_tabela_descricao">{{ oportunidade.grupo_regiao }}</td>
                                      </tr>
                                    }
                                    @if (oportunidade.subsegmento) {
                                      <tr>
                                        <td class="tabela_card_item_tabela_titulo">Subsegmento</td>
                                        <td class="tabela_card_item_tabela_descricao">{{ oportunidade.subsegmento }}</td>
                                      </tr>
                                    }
                                    @if (oportunidade.subsegmento2) {
                                      <tr>
                                        <td class="tabela_card_item_tabela_titulo">Subsegmento2</td>
                                        <td class="tabela_card_item_tabela_descricao">{{ oportunidade.subsegmento2 }}</td>
                                      </tr>
                                    }
                                    @if (oportunidade.rede_postos) {
                                      <tr>
                                        <td class="tabela_card_item_tabela_titulo">Rede Postos</td>
                                        <td class="tabela_card_item_tabela_descricao">{{ oportunidade.rede_postos }}</td>
                                      </tr>
                                    }
                                    <tr>
                                      <td class="tabela_card_item_tabela_titulo">Vendedor(a)</td>
                                      <td class="tabela_card_item_tabela_descricao">{{ oportunidade.fullname }}</td>
                                    </tr>
                                    @if (oportunidade.ultvisita != null && oportunidade.ultvisita != '') {
                                      <tr>
                                        <td class="tabela_card_item_tabela_titulo">Visita</td>
                                        <td class="tabela_card_item_tabela_descricao">{{ oportunidade.ultvisita | date: 'dd/MM/yyyy' }} - {{ oportunidade.qtdediasultvisita }} Dias</td>
                                      </tr>
                                    }
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Mês -->
                          <div class="tabela_card_item_quadro p-1">
                            <div class="d-flex flex-column">
                              <div class="text-center">
                                Mês
                              </div>
                              <div class="d-flex">
                                <div class="text-right tabela_card_item_valor">
                                  Objetivo
                                  <br />
                                  {{ oportunidade.objetivo_de_venda | currency: 'BRL' : '' }}
                                </div>
                                <div class="text-right tabela_card_item_valor">
                                  Realizado
                                  <br />
                                  {{ oportunidade.order_total | currency: 'BRL' : '' }}
                                </div>
                                <div class="text-right tabela_card_item_valor">
                                  Falta Vender
                                  <br />
                                  {{ oportunidade.falta_vender | currency: 'BRL' : '' }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Crédito -->
                          @if (oportunidade.limite_credito_cliente != null || oportunidade.limite_credito_utilizado != null || oportunidade.limite_credito_disponivel != null) {
                            <div class="tabela_card_item_quadro p-1">
                              <div class="d-flex flex-column">
                                <div class="text-center">
                                  Crédito
                                </div>
                                <div class="d-flex">
                                  <div class="text-right tabela_card_item_valor">
                                    Limite
                                    <br />
                                    {{ oportunidade.limite_credito_cliente != null ? (oportunidade.limite_credito_cliente | currency: 'BRL' : '') : '-' }}
                                  </div>
                                  <div class="text-right tabela_card_item_valor">
                                    Utilizado
                                    <br />
                                    {{ oportunidade.limite_credito_utilizado != null ? (oportunidade.limite_credito_utilizado | currency: 'BRL' : '') : '-' }}
                                  </div>
                                  <div class="text-right tabela_card_item_valor">
                                    Disponível
                                    <br />
                                    {{ oportunidade.limite_credito_disponivel != null ? (oportunidade.limite_credito_disponivel | currency: 'BRL' : '') : '-' }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                        <!-- Tags -->
                        <div class="d-flex flex-wrap">
                          @for (cliente_tag of oportunidade.cliente_tags; track cliente_tag) {
                            <div class="tabela_card_item_tag">
                              {{ cliente_tag.descricao }}
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </cdk-virtual-scroll-viewport>
        }
        @if (modelo_tela_ligacoes == 1) {
          <!-- Modelo 2 -->
          <!-- Exibição = Card -->
          <div class="pb-2">
            @if (oportunidades.length > 0) {
              <div class="pb-2">
                <div class="form-row">
                  <div class="form-group col-sm-2">
                    <label class="text-secondary"><b>Ordenar por:</b></label>
                    <select class="form-control form-control-sm" name="ordernar_oportunidades_por" [(ngModel)]="ordernarOportunidadesSelecionado" (change)="ordernarOportunidades($event.target.value)">
                      @for (opcao of ordernarOportunidadesOpcoes; track opcao) {
                        <option [value]="opcao.valor" [selected]="opcao.valor == ordernarOportunidadesSelecionado">{{ opcao.texto }}</option>
                      }
                    </select>
                  </div>
                  <div class="form-group col-sm-2">
                    <label class="text-secondary">&nbsp;</label>
                    <select class="form-control form-control-sm" name="ordernar_oportunidades_por_ordem" [(ngModel)]="ordernarOportunidadesOrdemSelecionado" (change)="ordernarOportunidadesOrdem($event.target.value)">
                      @for (opcao of ordernarOportunidadesOpcoesOrdem; track opcao) {
                        <option [value]="opcao.valor" [selected]="opcao.valor == ordernarOportunidadesOrdemSelecionado">{{ opcao.texto }}</option>
                      }
                    </select>
                  </div>
                </div>
              </div>
            }
            <cdk-virtual-scroll-viewport class="tabela_xl" [itemSize]="20">
              <table class="tabela_card">
                <tbody>
                  <tr *cdkVirtualFor="let oportunidade of oportunidades; let i = index; templateCacheSize: 0;">
                    <td>
                      <div class="d-flex flex-column justify-content-center tabela_card_item" [ngClass]="{ 'bg_tabela' : ((i % 2) == 0) }">
                        <div class="flex-grow-1">
                          <!-- Cliente -->
                          <div class="tabela_card_item_destaque mb-1">
                            <div class="d-flex justify-content-between">
                              <div class="d-flex">
                                <i class="fa fa-search-plus btn_tabela_acao pr-1" placement="right" ngbTooltip="Consultar" (click)="consultarCliente(oportunidade.client_id_app)"></i>
                                <i class="fa fa-tag btn_tabela_acao pr-1" placement="right" ngbTooltip="Tags (Clientes)" (click)="modalTagsClientes(tagsClientes, 'oportunidades', oportunidade.client_id_app)"></i>
                                <div>
                                  {{ oportunidade.name }}
                                </div>
                              </div>
                              <div class="d-flex">
                                <div>
                                  {{ oportunidade.estado }}
                                </div>
                                @if (oportunidade.client_document != null) {
                                  <div>
                                    &nbsp;- {{ oportunidade.client_document }}
                                  </div>
                                }
                                @if (oportunidade.zona_vendas != null) {
                                  <div>
                                    &nbsp;- {{ oportunidade.zona_vendas }}
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                          <div class="d-flex">
                            <div class="flex-grow-1">
                              <div class="d-flex flex-column">
                                <!-- Bagdes -->
                                <div class="d-flex mb-1">
                                  <div class="tabela_card_item_badge pr-1">
                                    @if (oportunidade.relationship == 'Ativo') {
                                      <span class="badge badge-warning">Ativo</span>
                                    }
                                    @if (oportunidade.relationship == 'Ativo batido') {
                                      <span class="badge badge-success">Ativo (Batido)</span>
                                    }
                                    @if (oportunidade.relationship == 'Ativo Premium') {
                                      <span class="badge badge-other">Ativo (Premium)</span>
                                    }
                                    @if (oportunidade.relationship == 'Inativo') {
                                      <span class="badge badge-danger">Inativo</span>
                                    }
                                    @if (oportunidade.relationship == 'Prospecção') {
                                      <span class="badge badge-primary">Prospecção</span>
                                    }
                                  </div>
                                  @if (oportunidade.atencao == 'S') {
                                    <span class="atencao">&nbsp;</span>
                                  }
                                </div>
                                <!-- Dados Complementares -->
                                <div class="tabela_card_item_quadro text-center mr-1">
                                  <div class="d-flex flex-column">
                                    <table>
                                      @if (oportunidade.call_center_prox_agenda != null) {
                                        <tr>
                                          <td class="tabela_card_item_tabela_titulo">Agendamento</td>
                                          <td class="tabela_card_item_tabela_descricao">{{ oportunidade.call_center_prox_agenda | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                        </tr>
                                      }
                                      @if (oportunidade.ultcomp != null && oportunidade.ultcomp != '') {
                                        <tr>
                                          <td class="tabela_card_item_tabela_titulo">Compra</td>
                                          <td class="tabela_card_item_tabela_descricao">{{ oportunidade.ultcomp | date: 'dd/MM/yyyy' }} - {{ oportunidade.qtdediasultcomp }} Dias</td>
                                        </tr>
                                      }
                                      <tr>
                                        <td class="tabela_card_item_tabela_titulo">PV</td>
                                        <td class="tabela_card_item_tabela_descricao">{{ oportunidade.pv }}</td>
                                      </tr>
                                      <tr>
                                        <td class="tabela_card_item_tabela_titulo">Segmento</td>
                                        <td class="tabela_card_item_tabela_descricao">{{ oportunidade.segment }}</td>
                                      </tr>
                                      @if (oportunidade.ramo_atividade) {
                                        <tr>
                                          <td class="tabela_card_item_tabela_titulo">Ramo Atividade</td>
                                          <td class="tabela_card_item_tabela_descricao">{{ oportunidade.ramo_atividade }}</td>
                                        </tr>
                                      }
                                      @if (oportunidade.grupo_regiao) {
                                        <tr>
                                          <td class="tabela_card_item_tabela_titulo">Grupo Região</td>
                                          <td class="tabela_card_item_tabela_descricao">{{ oportunidade.grupo_regiao }}</td>
                                        </tr>
                                      }
                                      @if (oportunidade.subsegmento) {
                                        <tr>
                                          <td class="tabela_card_item_tabela_titulo">Subsegmento</td>
                                          <td class="tabela_card_item_tabela_descricao">{{ oportunidade.subsegmento }}</td>
                                        </tr>
                                      }
                                      @if (oportunidade.subsegmento2) {
                                        <tr>
                                          <td class="tabela_card_item_tabela_titulo">Subsegmento2</td>
                                          <td class="tabela_card_item_tabela_descricao">{{ oportunidade.subsegmento2 }}</td>
                                        </tr>
                                      }
                                      @if (oportunidade.rede_postos) {
                                        <tr>
                                          <td class="tabela_card_item_tabela_titulo">Rede Postos</td>
                                          <td class="tabela_card_item_tabela_descricao">{{ oportunidade.rede_postos }}</td>
                                        </tr>
                                      }
                                      @if (oportunidade.ultvisita != null && oportunidade.ultvisita != '') {
                                        <tr>
                                          <td class="tabela_card_item_tabela_titulo">Visita</td>
                                          <td class="tabela_card_item_tabela_descricao">{{ oportunidade.ultvisita | date: 'dd/MM/yyyy' }} - {{ oportunidade.qtdediasultvisita }} Dias</td>
                                        </tr>
                                      }
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- Ano -->
                            <div class="tabela_card_item_quadro p-1 mr-1">
                              <div class="d-flex flex-column">
                                <div class="text-center">
                                  Ano
                                </div>
                                <div class="d-flex">
                                  <div class="text-right tabela_card_item_valor">
                                    Potêncial
                                    <br />
                                    {{ oportunidade.potencial_ano | currency: 'BRL' : '' }}
                                  </div>
                                  <div class="text-right tabela_card_item_valor">
                                    Realizado
                                    <br />
                                    {{ oportunidade.realizado_ano | currency: 'BRL' : '' }}
                                  </div>
                                  <div class="text-right tabela_card_item_porcentagem">
                                    %
                                    <br />
                                    {{ oportunidade.porcentagem_ano | currency: 'BRL' : '' }}
                                  </div>
                                  <div class="text-right tabela_card_item_valor">
                                    Falta
                                    <br />
                                    {{ oportunidade.falta_ano | currency: 'BRL' : '' }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- Mês -->
                            <div class="tabela_card_item_quadro p-1">
                              <div class="d-flex flex-column">
                                <div class="text-center">
                                  Mês
                                </div>
                                <div class="d-flex">
                                  <div class="text-right tabela_card_item_valor">
                                    Objetivo
                                    <br />
                                    {{ oportunidade.objetivo_de_venda | currency: 'BRL' : '' }}
                                  </div>
                                  <div class="text-right tabela_card_item_valor">
                                    Realizado
                                    <br />
                                    {{ oportunidade.realizado_venda | currency: 'BRL' : '' }}
                                  </div>
                                  <div class="text-right tabela_card_item_porcentagem">
                                    %
                                    <br />
                                    {{ oportunidade.porcentagem_venda | currency: 'BRL' : '' }}
                                  </div>
                                  <div class="text-right tabela_card_item_valor">
                                    Anterior
                                    <br />
                                    {{ oportunidade.realizado_venda_mesanterior | currency: 'BRL' : '' }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- Crédito -->
                            @if (oportunidade.limite_credito_cliente != null || oportunidade.limite_credito_utilizado != null || oportunidade.limite_credito_disponivel != null) {
                              <div class="tabela_card_item_quadro p-1">
                                <div class="d-flex flex-column">
                                  <div class="text-center">
                                    Crédito
                                  </div>
                                  <div class="d-flex">
                                    <div class="text-right tabela_card_item_valor">
                                      Limite
                                      <br />
                                      {{ oportunidade.limite_credito_cliente != null ? (oportunidade.limite_credito_cliente | currency: 'BRL' : '') : '-' }}
                                    </div>
                                    <div class="text-right tabela_card_item_valor">
                                      Utilizado
                                      <br />
                                      {{ oportunidade.limite_credito_utilizado != null ? (oportunidade.limite_credito_utilizado | currency: 'BRL' : '') : '-' }}
                                    </div>
                                    <div class="text-right tabela_card_item_valor">
                                      Disponível
                                      <br />
                                      {{ oportunidade.limite_credito_disponivel != null ? (oportunidade.limite_credito_disponivel | currency: 'BRL' : '') : '-' }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                          <!-- Tags -->
                          <div class="d-flex flex-wrap">
                            @for (cliente_tag of oportunidade.cliente_tags; track cliente_tag) {
                              <div class="tabela_card_item_tag">
                                {{ cliente_tag.descricao }}
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </cdk-virtual-scroll-viewport>
          </div>
        }
        @if (oportunidades.length > 0) {
          <div class="col-sm-12 text-right p-2">
            <button class="btn btn-link" type="button" (click)="exportarOportunidades()">Exportar p/ Excel</button>
          </div>
        }
      </div>
    </div>
  </div>
}
